export enum NavigationTrackingEvent {
  OpenPrimaryMenu = `[Navigation] Open Primary Menu`,
  SelectReport = `[Navigation] Select Report`,
}
